var React = require('react');

function WindowsLogoInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 12.402l35.687-4.86.016 34.423-35.67.203zm35.67 33.529l.028 34.453L.028 75.48.026 45.7zm4.326-39.025L87.314 0v41.527l-47.318.376zm47.33 39.349l-.012 41.34-47.318-6.678-.066-34.74z"}));
}

WindowsLogoInline.defaultProps = {"viewBox":"0 0 88 88"};

module.exports = WindowsLogoInline;

WindowsLogoInline.default = WindowsLogoInline;
